import { FeedAuthor } from "@pages/Article/utils/types";
import { cn } from "@util/helpers";

type ArticleBylineImageProps = {
  /** Author object containing image and name */
  author: FeedAuthor;
  /** Optional CSS class to apply to the image wrapper */
  className?: string;
  /** Width of the image */
  imageWidth?: number;
  /** Height of the image */
  imageHeight?: number;
};

/**
 * ArticleBylineImage component that displays the author's image in the byline.
 * It renders an image element with the author's image and alt text.
 */
const ArticleBylineImage = ({
  imageWidth = 50,
  imageHeight = 50,
  author,
  className,
}: ArticleBylineImageProps): React.ReactElement => {
  const imageUrl = author.image;

  const altName = author.name || "Author Image";

  return (
    <div
      className={cn("flex-shrink-0", className)}
      data-testid="article-byline-image-component"
    >
      <img
        className="aspect-square object-cover"
        src={imageUrl}
        alt={altName}
        width={imageWidth}
        height={imageHeight}
      />
    </div>
  );
};

export default ArticleBylineImage;
